import {
  Button,
  CircularProgress,
  Container,
  InputAdornment,
  makeStyles,
  Paper,
  TextField,
} from "@material-ui/core";
import FormattedMessage from "features/common/TranslatedMessage";
import InlineError from "features/common/InlineError";
import { useFormik } from "formik";
import qs from "query-string";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { resetPassword } from "slices/loginSlice";
import { extractApiErrorMessage } from "utils/apiErrorMessage";
import * as Yup from "yup";
import { Visibility, VisibilityOff } from "@material-ui/icons";
import { getQueryParams } from "features/intro/IntroVikalp/Helper";

const ResetPasswordSchema = Yup.object().shape({
  password: Yup.string()
    // .min(6, "Password Too Short!")
    // .max(20, "Password Too Long!")
    // .required("Password Required"),
    .min(6, "Password Too Short! Minimum Length - 6")
    .max(15, "Password Too Long! Maximum Length - 15")
    .matches(/^(.*[A-Z].*)/, "Must Contain an Upper Case Alphabet")
    .matches(/^(.*[a-z].*)/, "Must Contain a Lower Case Alphabet")
    .matches(/^(.*[0-9].*)/, "Must Contain a number")
    .matches(/^(.*\W.*)/, "Must Contain a special character")
    .required("Password Required"),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref("password"), null], "Passwords must match")
    .required("Confirm Password Required"),
});

const DEFAULT_ERROR =
  "Could not reset your password. This link may have expired — please request a new password reset email.";
const useStyles = makeStyles((theme) => {
  return {
    form: {
      width: "80%", // Fix IE 11 issue.
      marginTop: theme.spacing(1),
    },
    paper: {
      marginTop: theme.spacing(8),
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      padding: "2rem",
    },

    loginButton: {
      margin: theme.spacing(3, 0, 2),
      // backgroundColor: "#000",
      // color: "white",
      // border: "1px solid transparent",

      // "&:hover": {
      //   backgroundColor: "transparent",
      //   border: "1px solid #000",
      //   color: "#000",
      // },
    },
  };
});

export default function PasswordReset() {
  // const { token } = useParams();
  const history = useHistory();
  const { search } = useLocation();
  const email = getQueryParams("email", window.location.href);
  const { token } = qs.parse(search);
  const dispatch = useDispatch();

  const [passwordError, setPasswordError] = useState();

  const formik = useFormik({
    initialValues: {
      password: "",
      confirmPassword: "",
    },
    validationSchema: ResetPasswordSchema,
    onSubmit: async (values) => {
      setPasswordError();
      try {
        let result = await resetPassword({
          email,
          token,
          password: values.password,
        });
        if (result?.status === "OK") {
          history.push("/reset-password-confirm");
        } else {
          setPasswordError(extractApiErrorMessage(result, DEFAULT_ERROR));
        }
      } catch (err) {
        // Rejects with the raw response body: a weak password comes back as
        // { password: [...] }, a stale link with no field map at all.
        setPasswordError(extractApiErrorMessage(err, DEFAULT_ERROR));
      }
    },
  });

  const classes = useStyles();

  const onPasswordChange = (e) => {
    setPasswordError();
    formik.setFieldValue("password", e.target.value);
  };

  const [passwordType, setPasswordType] = useState("password");
  const tooglePasswordType = () => {
    if (passwordType == "password") {
      setPasswordType("text");
    } else {
      setPasswordType("password");
    }
  };

  return (
    <Container component="main" maxWidth="sm">
      <Paper className={classes.paper}>
        <form
          className={classes.form}
          noValidate
          onSubmit={formik.handleSubmit}
        >
          <TextField
            variant="filled"
            margin="normal"
            type={passwordType}
            value={formik.values.password}
            required
            fullWidth
            id="password"
            label={<FormattedMessage id="auth.password" />}
            name="password"
            autoComplete="password"
            autoFocus
            onBlur={formik.handleBlur}
            // onChange={formik.handleChange}
            onChange={onPasswordChange}
            // onChange={formik.handleChange}
            InputProps={{
              endAdornment: (
                <InputAdornment
                  position="end"
                  onClick={tooglePasswordType}
                  style={{ cursor: "pointer" }}
                >
                  {passwordType == "password" ? (
                    <VisibilityOff />
                  ) : (
                    <Visibility />
                  )}
                </InputAdornment>
              ),
            }}
          />
          <InlineError
            message={
              (formik.touched.password && formik.errors.password) || ""
            }
          />
          <TextField
            variant="filled"
            margin="normal"
            type={passwordType}
            value={formik.values.confirmPassword}
            required
            fullWidth
            id="confirmPassword"
            label={<FormattedMessage id="auth.confirmPassword" />}
            name="confirmPassword"
            autoComplete="confirmPassword"
            onBlur={formik.handleBlur}
            onChange={(e) => {
              formik.handleChange(e);
              setPasswordError();
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment
                  position="end"
                  onClick={tooglePasswordType}
                  style={{ cursor: "pointer" }}
                >
                  {passwordType == "password" ? (
                    <VisibilityOff />
                  ) : (
                    <Visibility />
                  )}
                </InputAdornment>
              ),
            }}
          />
          <InlineError
            message={
              (formik.touched.confirmPassword &&
                formik.errors.confirmPassword) ||
              ""
            }
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            disabled={formik.isSubmitting}
            className={classes.loginButton}
          >
            {formik.isSubmitting ? (
              <CircularProgress size={20} color="inherit" />
            ) : (
              <FormattedMessage id="auth.resetPassword" />
            )}
          </Button>
          <InlineError message={passwordError} style={{ marginTop: 0 }} />
        </form>
      </Paper>
    </Container>
  );
}
